






























































































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import CContentTop from "@/components/CContentTop.vue";
import { Input, Select, Button, Pagination } from "ant-design-vue";
import SystemFrom from "./components/systemFrom.vue";
import FlowType from "./components/flowType.vue";
import CDepartment from "@/components/CDepartment.vue";

const _params = {
  pageNum: 1,
  pageSize: 20,
  sortBy: "",
  order: "",
  pendType: "1",
  status: "2",
  receiverUserCode: "",
  procedureName: "",
  promoter: "",
  systemName: "",
  promoterOrg: "",
  title: "",
  processType: ""
};

@Component({
  name: "Flow",
  components: {
    CContentTop,
    SystemFrom,
    FlowType,
    CDepartment,
    AInput: Input,
    ASelect: Select,
    ASelectOption: Select.Option,
    AButton: Button,
    APagination: Pagination
  }
})
export default class Flow extends Base {
  private dataSource: any[] = [];
  /**
   * taskType：任务类型
   * daiban： 待办，daiyue：待阅
   */
  private currentTaskIdx = 0;
  private leftNav: any[] = [
    { label: "待办任务", key: "daiban", icon: "icondaiban", count: 0, pendType: "1" },
    { label: "待阅任务", key: "daiyue", icon: "icondaiyue", count: 0, pendType: "2" }
  ];
  private tableHeader: any[] = [
    { label: "流程标题", key: "title", order: "desc" },
    { label: "创建时间", key: "initiationTime", order: "desc" },
    { label: "发起人", key: "promoter", order: "desc" },
    { label: "发起部门", key: "promoterOrg", order: "desc" },
    { label: "流程名称", key: "procedureName", order: "desc" },
    { label: "系统来源", key: "systemName", order: "desc" },
    { label: "接收时间", key: "receiverTime", order: "desc" }
  ];
  // 排序索引，对应tableHeader
  private orderIdx = 1;

  private total = 0;

  // 接口相关参数 START
  private params: any = {};
  // 接口相关参数 END

  // 系统来源
  private systemFrom = "";
  // 流程类型
  private processType = "";

  private timer: any = null;

  private destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  private created() {
    this.reset();
    this.getProcessCount();

    this.timer = setInterval(() => {
      this.getProcessList();
    }, 30000);
  }

  private changeOrder(idx: number) {
    const order = this.tableHeader[idx].order === "desc" ? "asc" : "desc";
    this.$set(this.tableHeader[idx], "order", order);
    this.orderIdx = idx;
    this.getProcessList();
  }

  private onChange() {
    this.dataSource = [];
    this.getProcessList();
  }

  private onShowSizeChange() {
    this.search();
  }

  private changeTask(idx: number) {
    this.currentTaskIdx = idx;
    this.$set(this.params, "pageNum", 1);
    this.dataSource = [];
    this.getProcessList();
  }

  private getProcessCount() {
    // 获取待办数量
    this.$api
      .ProcessCount({
        pendType: "1",
        status: "2",
        receiverUserCode: this.currentUser.userNo
      })
      .then((res: Api.Response) => this.$set(this.leftNav[0], "count", res.data));

    // 获取待阅数量
    this.$api
      .ProcessCount({
        pendType: "2",
        status: "2",
        receiverUserCode: this.currentUser.userNo
      })
      .then((res: Api.Response) => this.$set(this.leftNav[1], "count", res.data));
  }

  private async getProcessList() {
    const res = await this.$api.ProcessList(this.processListParams);
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = res.rows;
    }
  }

  private search() {
    this.dataSource = [];
    this.$set(this.params, "pageNum", 1);
    this.getProcessList();
  }

  private reset() {
    this.params = { ..._params };
    this.dataSource = [];
    this.getProcessList();
  }

  private get processListParams() {
    const _return = { ...this.params };
    _return.receiverUserCode = this.currentUser.userNo;
    _return.pendType = this.leftNav[this.currentTaskIdx].pendType;
    _return.sortBy = this.tableHeader[this.orderIdx].key;
    _return.order = this.tableHeader[this.orderIdx].order;
    return _return;
  }
}
